import { Tooltip } from "@design-system/DataDisplay/Tooltip";
import { Icon } from "@design-system/Icon";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { GetObjectiveQuery } from "@generated/client/graphql";
import { type FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { isObjectiveEditable } from "../../services";
import { DatapointValueDisplay } from "./DatapointValueDisplay";
import { keys, RESOURCE_NAME } from "./i18n";
import { IndicatorsCombobox } from "./IndicatorsCombobox";
import { Targets } from "./Targets";

type ObjectiveContentProps = {
    objective: GetObjectiveQuery["objective"];
};

export const ObjectiveContent: FC<ObjectiveContentProps> = ({ objective }) => {
    const { t } = useTranslation(RESOURCE_NAME);

    const canEditObjective = useMemo(
        () => isObjectiveEditable(objective),
        [objective],
    );

    return (
        <FlexCol w="full" gap="6">
            <FlexCol gap="2" w="full">
                <Text color="secondary">{t(keys.target_desc)}</Text>
                <FlexRow gap="4" w="full" alignItems="center">
                    <IndicatorsCombobox
                        objective={objective}
                        editable={canEditObjective}
                    />
                    <Tooltip>
                        <Tooltip.Trigger asChild>
                            <Icon
                                size="sm"
                                name="circleInfo"
                                className="text-secondary"
                            />
                        </Tooltip.Trigger>
                        <Tooltip.Content className="max-w-[400px]">
                            {t(keys.hint_indicator)}
                        </Tooltip.Content>
                    </Tooltip>
                </FlexRow>
            </FlexCol>
            <FlexCol gap="4">
                <DatapointValueDisplay objective={objective} />
                <Targets objective={objective} />
            </FlexCol>
        </FlexCol>
    );
};
